import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Helmet from "react-helmet";
import {config} from "../../../../config";
import "./AskForAuthorization.scss";
import {updateCurrentUserRightModerationTag} from "../../../../creators/currentUser";
import pictoUser from "./images/user.png";
import pictoSolidarity from "./images/solidarity.png";
import pictoTime from "./images/time-forward-sixty.png";
import pictoShield from "./images/shield-check.png";
import pictoHeart from "./images/heart.png";
import {Button} from "../../../components/Button";

class AskForAuthorization extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error : {
                message : "",
                display : false
            }
        }
        this.updateRight = this.updateRight.bind(this);
    }

    updateRight(){
        this.setState({error : {message : ""}});
        this.props.updateCurrentUserRightModerationTag().then(({error, data}) =>{
            if(!error){
                let url = `${window.location.protocol}//${window.location.host}/tag-moderations/qualifications`;
                window.location = url;
            }
            else{
                this.setState({error : {display : true, message : "impossible de mettre a jour votre compte"}})
            }

        }).catch(e =>{
            this.setState({error : {display : true, message : "impossible de mettre a jour votre compte"}})
        })
    }

    render() {
        return (
            <div id="tag-moderations-qualifications-ask-for-authorization">
                <Helmet>
                    <title>{config.preTitle} Tag Moderations autorisation {config.postTitle}</title>
                </Helmet>
                <div className="container">
                    <div className="taggage_main">
                        <div className="illustration"></div>
                        <div className="taggage_main_content">
                            <h1 className="taggage_main_content_title">Taggage des médias sur Voissa</h1>
                            <p className="taggage_main_content_subtitle">Le taggage des médias est essentiel pour entretenir un environnement de liberté et de confiance.</p>
                            <hr />
                            <p className="span">Consacrez-y régulièrement<b> 5 minutes et aidez-nous à faire la différence </b>pour :</p>
                            <div className="taggage_main_content_cta">
                                <div className="taggage_main_content_cta_card">
                                    <img src={pictoUser} alt={""} />
                                    <div>
                                        <h3>Détecter les faux profils</h3>
                                        <p>(Usurpation d’identité, etc.)</p>
                                    </div>
                                </div>
                                <div className="taggage_main_content_cta_card">
                                    <img src={pictoSolidarity} alt={""} />
                                    <div>
                                        <h3>Respecter la sensibilité de chacun</h3>
                                        <p>En cachant les contenu explicites à ceux qui préfèrent une approche plus érotique.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="taggage_picto">
                        <div className="taggage_picto_pictos">
                            <div className="taggage_picto_pictos_card">
                                <img src={pictoTime} alt={""} />
                                <p>5 min</p>
                            </div>
                            <div className="taggage_picto_pictos_card">
                                <img src={pictoShield} alt={""} />
                                <p>Protéger Voissa</p>
                            </div>
                            <div className="taggage_picto_pictos_card">
                                <img src={pictoHeart} alt={""} />
                                <p>Un Don Utile</p>
                            </div>
                        </div>

                        <Button size={"small"}
                                className={"taggage_picto_btn btn"}
                                btnStyle={"custom"}
                                onClick={() => this.updateRight()}
                                content="Je souhaite aider Voissa !"/>
                    </div>
                    {this.state.error.display ? (
                        <div className={"text-danger text-align-center"}>{this.state.error.message}</div>
                    ) : null}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserInitialized : state.currentUser.initialized,
        currentUserLoading : state.currentUser.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateCurrentUserRightModerationTag
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AskForAuthorization);